module.exports = __webpack_public_path__ + "static/img/item1.7671e3ca.png";